import { typographyV2 } from '@toggle/design-system';
import styled from 'styled-components';

export const Title = styled.div`
  height: 28px;
  display: flex;
  align-items: center;
  ${typographyV2.bodySm}
`;
